// extracted by mini-css-extract-plugin
export default {"wrapper":"ganttView_wrapper__GJnQo"};